import { Document, Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  pageContentRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  labelBox: {
    flex: 1,
    borderWidth: 1,
    padding: 10,
    marginHorizontal: 5,
    width: "228px",
    height: "190px",
    overflow: "hidden"
  },
  titlesList: {
    flex: 1,
    marginHorizontal: 5,
    borderWidth: 1,
    padding: 8,
    fontSize: 7,
    width: "228px",
    height: "200px",
    fontWeight: 'bold',
  },
  titleItem: {
    marginBottom: 2,
  },
  labelCode: {
    textAlign: 'center',
    marginVertical: 4,
    fontWeight: 'bold',
  },
  labelDetails: {
    textAlign: 'center',
    marginVertical: 1,
    fontWeight: 'bold',
  },
logoLTO: {
  height: 40,
  marginBottom: 4,
},

logoContainer: {
  height: 44, 
},

titleListContainer: {
  flexGrow: 1,
  overflow: 'hidden',
  marginLeft:10,
},

});

interface PdfProps {
  originalLto: string;
  clonedLto: string;
  ltoType: string[];
  selectedTitles:string[];
}

const LtoPdfDocument: React.FC<PdfProps> = ({
  originalLto,
  clonedLto,
  ltoType,
  selectedTitles
}) => {





  const renderLabelBox = (lto: string) => (
    <View style={styles.labelBox}>
      <Image src="/assets/labelHeading.png" style={styles.logoLTO} />
      <Text style={styles.labelCode}>{lto.toUpperCase()}</Text>
      <Text style={styles.labelDetails}>
        FD Documentries ({selectedTitles.length} Titles)
      </Text>
      <View style={{ marginTop: 8 }}>
        {ltoType.map((type) => (
          <Text key={type} style={styles.labelDetails}>
            {type}
          </Text>
        ))}
      </View>
       <View style={{ marginTop: 5 }}>
        <Text style={styles.labelDetails}>DCP</Text>
        <Text style={styles.labelDetails}>ProRes</Text>
        <Text style={styles.labelDetails}>MP4</Text>
      </View>
    </View>
  );

const renderTitlesList = (keyPrefix: string) => (
  <View style={styles.titlesList}>
    {/* Fixed-size logo container */}
    <View style={styles.logoContainer}>
      <Image src="/assets/labelHeading.png" style={styles.logoLTO} />
    </View>

    {/* Scrollable / shrinkable title list */}
    <View style={styles.titleListContainer}>
      {selectedTitles.map((title, index) => (
        <Text key={`${keyPrefix}-${index}`} style={styles.titleItem}>
          {`${(index + 1).toString().padStart(2, '0')}. ${title}`}
        </Text>
      ))}
    </View>
  </View>
);


  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* First pair */}
        <View style={styles.pageContentRow}>
          {renderLabelBox(originalLto)}
          {renderLabelBox(clonedLto)}
        </View>
        <View style={styles.pageContentRow}>
          {renderTitlesList('orig1')}
          {renderTitlesList('clone1')}
        </View>
         {/* First pair */}
        {/* <View style={styles.pageContentRow}>
          {renderLabelBox(originalLto)}
          {renderLabelBox(clonedLto)}
        </View>
        <View style={styles.pageContentRow}>
          {renderTitlesList('orig1')}
          {renderTitlesList('clone1')}
        </View> */}
      </Page>
    </Document>
  );
};

export default LtoPdfDocument;
